import {Ref} from "vue";

function clearValidation(inError: Ref<{ [key: string]: string }>, e: InputEvent & { target: { id: string } }) {
    const key = e?.target?.id as string;
    if (key)
        delete inError.value[key]
}

const validationEmail = (v: any) => v && v.trim() != '' && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v)

export {
    clearValidation,
    validationEmail
}
